// i18next-extract-mark-ns-start BeTilliste

import React from 'react';
import styled from 'styled-components';
import { Link } from '../services/link';
import { Button as StyledButton } from './home/v3/styledComponents';
import routesMap from '../Routes';

const Button = styled(StyledButton)`
  @media (max-width: ${({ theme }) => theme.tabletThresholdPixels}) {
    margin-bottom: 60px;
  }
`;

const Row = styled.div`
  ${({ beige, theme }) => beige && `background-color: ${theme.colors.grey100};`}
  padding: 52px 0px 18px;
  &:first-of-type {
    padding-top: 0px;
  }
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-bottom: 38px;
  @media (max-width: ${({ theme }) => theme.tabletThresholdPixels}) {
    margin-bottom: 0px;
    padding-top: 39px;
    padding: 39px 24px 0px;
    &:first-of-type {
      padding: 0px;
    }
  }
`;

const Text = styled.p`
  max-width: 1193px;
  font-family: Roboto;
  font-size: 18px;
  font-weight: 400;
  line-height: 24px;
  margin: 0px;
  ${({ marginTop }) => marginTop && 'margin-top: 32px;'}
  ${({ textAlignCenter }) => textAlignCenter && 'text-align: center;'}
  @media (max-width: ${({ theme }) => theme.tabletThresholdPixels}) {
    font-size: 14px;
    line-height: 19px;
    max-width: unset;
  }
`;

const Title = styled.p`
  max-width: 623px;
  font-size: 32px;
  font-weight: 700;
  line-height: 43px;
  text-align: center;
  margin-bottom: 4px;
  margin-top: 0px;
  letter-spacing: 2px;
  @media (max-width: ${({ theme }) => theme.tabletThresholdPixels}) {
    font-size: 18px;
    line-height: 24px;
  }
`;

const SubTitle = styled.p`
  max-width: 315px;
  font-family: Roboto;
  font-size: 18px;
  color: ${({ theme }) => theme.colors.black};
  line-height: 24px;
  text-align: center;
  margin: 6px 0px 30px;
  font-style: italic;
  @media (max-width: ${({ theme }) => theme.tabletThresholdPixels}) {
    font-size: 14px;
    line-height: 19px;
  }
`;

const TextContainer = styled.div`
  display: flex;
  flex-direction: column;
  margin-bottom: 74px;
  ${({ isFooter }) => isFooter && `
    margin-top: 50px;
    max-width: 547px;
  `}
  @media (max-width: ${({ theme }) => theme.tabletThresholdPixels}) {
    margin-bottom: 23px;
    ${({ isFooter }) => isFooter && `
      margin-top: 30px;
    `}
  }
`;

const YellowSpan = styled.span`
  color: ${({ theme }) => theme.colors.yellow800};
  font-weight: 600;
  ${({ noMargin }) => !noMargin && 'margin-left: 5px;'}
`;

const WhyContainer = styled.div`
  margin-top: 80px;
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  max-width: 1193px;
  justify-content: space-between;
  @media (max-width: ${({ theme }) => theme.tabletThresholdPixels}) {
    margin-top: 40px;
    margin-bottom: 18px;
  }
`;

const WhySubContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-bottom: 99px;
  max-width: 251px;
  @media (max-width: ${({ theme }) => theme.tabletThresholdPixels}) {
    max-width: unset;
    width: 47%;
    margin-bottom: 35px;
  }
`;

const WhyTitle = styled.p`
  font-size: 26px;
  color: ${({ theme }) => theme.colors.yellow800};
  line-height: 35px;
  text-align: center;
  margin-bottom: 8px;
  margin-top: 0px;
  letter-spacing: 0.1em;

  @media (max-width: ${({ theme }) => theme.tabletThresholdPixels}) {
    font-size: 18px;
    line-height: 24px;
  }
`;

const WhyText = styled.p`
  font-family: Roboto;
  font-size: 18px;
  font-weight: 400;
  line-height: 24px;
  text-align: center;
  margin: 0px;
  @media (max-width: ${({ theme }) => theme.tabletThresholdPixels}) {
    font-size: 14px;
    line-height: 19px;
  }
`;

const UpTitle = styled.p`
  margin: 0px;
  margin-bottom: 15px;
  font-family: Roboto;
  font-weight: 500;
  font-size: 12px;
  line-height: 30px;
  text-transform: uppercase;
  letter-spacing: 5.5px;

  @media (max-width: ${({ theme }) => theme.tabletThresholdPixels}) {
    margin-bottom: 10px;
    font-size: 10px;
  }
`;

export const renderBecomeTillisteButton = (t) => (
  <Link to={routesMap.BeTillistePage.url}>
    <Button black>{t('Devenez Tilliste')}</Button>
  </Link>

);

export const renderBecomeTilliste = (t, isMobile) => (
  <Row beige>
    <Title>{t('Vous êtes couturier et souhaitez vivre de votre passion ?')}</Title>
    <SubTitle>{t('Devenez Tilliste en freelance !')}</SubTitle>
    <TextContainer>
      <Text>
        {t('Soyez votre propre patron et gérez votre agenda comme vous le souhaitez.')}
        {t('Vous êtes couturier styliste modéliste, vous êtes passionné et avez envie de transmettre votre amour de la couture.')}
      </Text>
      <Text>
        {t('Intégrez la Maison Tilli et partagez votre savoir-faire.')}
        {isMobile ? ' ' : ''}
        {isMobile ? <YellowSpan noMargin>{t('Gagnez jusqu’à 3 500 €.')}</YellowSpan> : ''}
      </Text>
      {!isMobile && <Text><YellowSpan noMargin>{t('Gagnez jusqu’à 3 500 €.')}</YellowSpan></Text>}
      <Text marginTop>{t('Passez un moment unique avec vos clients et cousez passionnément.')}</Text>
      <Text>{t('Faites partie d’une communauté de couturiers modélistes stylistes en intégrant la Maison Tilli.')}</Text>
    </TextContainer>
  </Row>
);

const why = (t) => [
  { title: t('Flexibilité'), text: t('Vous recevez des missions selon vos disponibilités') },
  { title: t('Confort'), text: t('Vous travaillez de chez vous / dans votre atelier') },
  { title: t('Liberté'), text: t('Soyez votre propre patron') },
  { title: t('Gestion'), text: t('Tilli s’occupe de la facturation') },
  { title: t('Simplicité'), text: t('Nos tarifs sont fixes, vous n’avez pas à négocier') },
  { title: t('€€€'), text: t('Gagnez jusqu’à 3 500€') },
  { title: t('Customer care'), text: t('La Maison Tilli s’occupe du suivi des clients') },
  { title: t('Partage'), text: t('Apprenez et transmettez votre savoir-faire à travers des ateliers') },
];

export const renderWhyTilli = (t) => (
  <Row>
    <UpTitle>{t('Nos valeurs')}</UpTitle>
    <Title>{t('Pourquoi Tilli ?')}</Title>
    <WhyContainer>
      {why(t).map(({ title, text }) => (
        <WhySubContainer key={title}>
          <WhyTitle>{title}</WhyTitle>
          <WhyText>{text}</WhyText>
        </WhySubContainer>
      ))}
    </WhyContainer>
    {renderBecomeTillisteButton(t)}
  </Row>
);
